import { request, ResponseData } from "./instance";
import duyin from "@/utils/duyin.json";
import Logger from "@/utils/Logger";
import { removeEmoji } from "@/utils/subtitleMessageHandler";

const headers = {
  "Content-Type": "application/json; charset=UTF-8",
  Authorization: "Bearer;uM5bjb3CknbTRgcC8ikq6uRKRkJQTp7A",
};

const DEFAULT_SPEED_RATIO = 1.0;

const requestData = {
  app: {
    appid: "2326791206",
    token: "uM5bjb3CknbTRgcC8ikq6uRKRkJQTp7A",
    cluster: "volcano_tts",
  },
  user: {
    uid: "388808087185088",
  },
  audio: {
    voice_type: "BV001_streaming", //"BV123_streaming",//"BV064_streaming",
    encoding: "mp3",
    speed_ratio: DEFAULT_SPEED_RATIO,
    volume_ratio: 1.0,
    pitch_ratio: 1.0,
    emotion: "",
    language: "cn",
  },
  request: {
    reqid: "",
    text: "",
    text_type: "ssml",
    operation: "query",
    with_frontend: 1,
    frontend_type: "unitTson"
  },
};

export async function asyncGetAudio(
  str: string,
  voiceConfig: any = null,
  language = "en",
  voiceRatio: number = 0,
) {
  let msg = removeEmoji(str);
  if (!msg) {
    Logger.info("not valid text, no need to request audio for:", str);
    return {
      error: true,
      msg: "**空字符串，不需求请求语音**",
    };
  }

  let retryCount = 0;

  let audioRes;
  while (retryCount < 3) {
    audioRes = await asyncGetAudioRequest(
      str,
      language,
      voiceConfig,
      voiceRatio,
    );
    if (!audioRes.error || retryCount === 2) {
      return audioRes;
    }
    retryCount++;
  }
  return {
    error: true,
    msg: "**语音生成错误**",
  };
}

/**
 * send request to backend service to get the audio for a text
 * @param {*} str
 * @returns
 */
export async function asyncGetAudioRequest(
  str: string,
  language: string,
  voiceConfig: any,
  voiceRatio: number,
) {
  let tmp_str = str;
  const duyinJson: { [key: string]: string } = duyin;

  tmp_str = tmp_str
    ?.replace(/\\n/g, "")
    .replace(/\\\\n/g, "")
    .replace(/\\"/g, "");
  // tmp_str = tmp_str?.replace(/'/g, "");
  // tmp_str = tmp_str?.replace(/`/g, ""); //remove it because it will cause error:you're doing great!  ---> youre doing great!
  // tmp_str = tmp_str?.replace(/"/g, "");
  tmp_str = tmp_str?.replace(/\\/g, "");
  // tmp_str = tmp_str?.replace(/"/g, "");
  // tmp_str = tmp_str?.replace(/"/g, "");
  tmp_str = tmp_str?.replace(/</g, "");
  tmp_str = tmp_str?.replace(/>/g, "");
  tmp_str = tmp_str?.replace(/\*/g, "");
  // tmp_str = tmp_str.replaceAll(
  //   /(\p{Emoji_Modifier_Base}\p{Emoji_Modifier}?|\p{Emoji_Presentation}|\p{Emoji}\uFE0F)/gu,
  //   ""
  // );

  tmp_str = tmp_str?.replace(
    /([\uD83C-\uDBFF\uDC00-\uDFFF]+|[\u2694-\u2697\u2699\u269B\u269C\u26A0\u26A1\u26AA\u26AB\u26B0\u26B1\u26BD\u26BE\u26C4\u26C5\u26CE\u26CF\u26D1\u26D3\u26E9\u26EA\u26F0-\u26F5\u26F7\u26F8\u26FA\u26FD\u2702\u2705\u2708-\u270D\u270F\u2712\u2714\u2716\u271D\u2721\u2728\u2733\u2734\u2744\u2747\u274C\u274E\u2753-\u2755\u2757\u2763\u2764\u2795-\u2797\u27A1\u27B0\u27BF\u2934\u2935\u2B05-\u2B07\u2B1B\u2B1C\u2B50\u2B55\u3030\u303D\u3297\u3299])/g,
    "",
  );

  for (var key in duyin) {
    tmp_str = tmp_str?.replace(key, duyinJson[key]);
  }

  tmp_str = `<speak>${tmp_str}</speak>`;
  // const numberRegex = /[-+]?\d*\.\d+/g;
  //
  // // 使用 replace 方法替换匹配到的数字
  // tmp_str = tmp_str.replace(numberRegex, (match) => {
  //   return `<say-as interpret-as="number">${match}</say-as>`;
  // });

  requestData.request["text"] = tmp_str;
  requestData.request["reqid"] = createsid();

  if (voiceConfig && voiceConfig?.voice_type)
    requestData.audio["voice_type"] = voiceConfig?.voice_type;

  if (voiceRatio > 0) {
    requestData.audio["speed_ratio"] =
      language === "en" ? voiceRatio : voiceRatio + 0.1;
  } else if (voiceConfig && voiceConfig?.speed_ratio)
    requestData.audio["speed_ratio"] = voiceConfig?.speed_ratio;
  else {
    requestData.audio["speed_ratio"] = DEFAULT_SPEED_RATIO;
  }

  if (voiceConfig && voiceConfig?.emotion)
    requestData.audio["emotion"] = voiceConfig?.emotion;

  let lan = language
    ? language
    : voiceConfig && voiceConfig.language
    ? voiceConfig.language
    : "en";

  requestData.audio["language"] = lan;

  // if (lan === "en") {
  //   requestData.audio["speed_ratio"] = 0.9;
  // }

  try {
    // seriesId 4/15 走 nginx /oldtts -> openspeech api/v1/tts（Volcano）
    let response = await request("oldtts", {
      method: "post",
      data: requestData, //str
      headers,
      prefixUrl: "/",
    });

    if (response && response.data) {
      return response;
    } else {
      return {
        error: true,
        msg: "**语音生成错误**",
      };
    }
  } catch (error) {
    return {
      error: true,
      msg: "**语音生成错误**",
    };
  }
}

function createsid() {
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (c) {
    const r = (Math.random() * 16) | 0,
      v = c === "x" ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
}
